import DynamicDropdownListObject from './DynamicDropdownListObject';

export default DynamicDropdownListObject;
